
//Form State
import { getModel } from '../../model/registry'
import useFormValidation from "../cardView/useFormValidation";

//Importing the Subcomponents
import FixedView from "./FixedView";
import ResizableView from "./ResizableView";

const MultiView = ({ type, options, dispatch}) => {

  let resizeable = true
  if (options?.resizeable) resizeable = options.resizeable

  //Config to read the data from the Model
  const config = getModel('multiViewData')[type]
  if (!config) return <span>No real config found for {type}</span>
  const sidePanelConfig = getModel('sidePanelData')[config.sidePanel ?? config.sidePanelType]

  //const { validated } = useFormValidation()
  const { validated } = useFormValidation(config.entity)

  return (
    <>
      {
        !resizeable && <FixedView options={options} validated={validated}
          sidePanelConfig={sidePanelConfig} config={config} type={type} dispatch={dispatch} />

      } {resizeable && <ResizableView options={options} validated={validated}
        sidePanelConfig={sidePanelConfig} config={config} dispatch={dispatch} type={type} />}
    </>
  );
};

export default MultiView;
